<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('administrativePosition.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('administrativePosition.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'name' + _uid" class="font-weight-bold">{{ $t('administrativePosition.name')
                                }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="administrativePosition.name"
                                   readonly/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-6">
                            <label :for="'department' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.department') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="administrativePosition.departmentName"
                                   readonly/>
                        </div>
                        <div class="form-group col-6">
                            <label :for="'directorate' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.directorate') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="administrativePosition.directorateName"
                                   readonly/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-6">
                            <label :for="'managerPosition' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.managerPosition') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="administrativePosition.managerPosition"
                                   readonly/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'contactDetails' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.contactDetails') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="administrativePosition.contactDetails"
                                   readonly/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'location' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.location') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="administrativePosition.location"
                                   readonly/>
                            <span class="text-danger" v-if="errors.has('location' + _uid)">{{ errors.first('location' + _uid) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3" v-if="administrativePosition.replacements.length >0">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('administrativePosition.substitutions') }}</div>
                </div>
                <div class="card-body">
                    <div class="card-body col-12">
                        <div v-for="(replacement,index) in administrativePosition.replacements" :key="index" class="mt-3">
                            <div class="form-control mb-3 col-6">
                                <label :for="'name' + _uid" class="font-weight-bold">{{
                                    $t('administrativePosition.name') }}</label>
                            </div>
                            <input type="text"
                                   class="form-control"
                                   v-model="replacement.replacement"
                                   readonly/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
                </div>
                <div class="card-body">
                    <otherFieldsDetails :otherFields="administrativePosition.otherFields"></otherFieldsDetails>
                </div>
            </div>

            <div class="mt-3" v-if="administrativePosition">
                <AuxiliaryRegisterDetails :entryId="administrativePosition.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import OtherFieldsDetails from '../../../components/otherFields/OtherFieldsDetails.vue';
    import { AdministrativePositionDetails } from '../../../models/models';
    import PageTitle from '../../../components/common/PageTitle';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            OtherFieldsDetails,
            PageTitle,
            AuxiliaryRegisterDetails
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                administrativePosition: new AdministrativePositionDetails(),
                loading: false,
            }
        },
        methods: {
            backToRegister() {
                this.$router.push(this.returnUrl || '/registers/administrativePositions');
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/administrativePosition/GetDetails/${this.id}`).then(result => {
                    this.administrativePosition = new AdministrativePositionDetails(result.data);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.loadData();
        }
    }

</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
